export default __webpack_public_path__ + "static/media/flag-turkmenistan.b17cea53.svg";